import clsx from 'clsx';
import { FaToilet, FaUtensils } from 'react-icons/fa';

import {
	MdAcUnit,
	MdAirlineSeatFlat,
	MdAirlineSeatLegroomExtra,
	MdAirlineSeatLegroomNormal,
	MdAirlineSeatLegroomReduced,
	MdCoffee,
	MdCookie,
	MdEnergySavingsLeaf,
	MdEventSeat,
	MdHotelClass,
	MdLoyalty,
	MdMovie,
	MdNewspaper,
	MdPower,
	MdSmartDisplay,
	MdUsb,
	MdVideogameAsset,
	MdWifi,
} from 'react-icons/md';

import { GiWaterBottle } from 'react-icons/gi';

export default function AmenityIcon({ amenityId, className, FallbackIcon }) {
	try {
		switch (amenityId) {
			case 'airConditioning':
				return <MdAcUnit className={clsx(className)} />;
			case 'bathroom':
				return <FaToilet className={clsx(className)} />;
			case 'beverage':
				return <MdCoffee className={clsx(className)} />;
			case 'entertainmentNoWifi':
				return <MdSmartDisplay className={clsx(className)} />;
			case 'extraLegroom':
				return <MdAirlineSeatLegroomExtra className={clsx(className)} />;
			case 'freeWater':
				return <GiWaterBottle className={clsx(className)} />;
			case 'games':
				return <MdVideogameAsset className={clsx(className)} />;
			case 'greenCert':
				return <MdEnergySavingsLeaf className={clsx(className)} />;
			case 'hotMeal':
				return <FaUtensils className={clsx(className)} />;
			case 'lieflatSeatOrBed':
				return <MdAirlineSeatFlat className={clsx(className)} />;
			case 'limitedLegroom':
				return <MdAirlineSeatLegroomReduced className={clsx(className)} />;
			case 'loyaltyReward':
				return <MdLoyalty className={clsx(className)} />;
			case 'luxury':
				return <MdHotelClass className={clsx(className)} />;
			case 'movie':
				return <MdMovie className={clsx(className)} />;
			case 'newspaperMagazine':
				return <MdNewspaper className={clsx(className)} />;
			case 'snacks':
				return <MdCookie className={clsx(className)} />;
			case 'powerOutlet':
				return <MdPower className={clsx(className)} />;
			case 'standardSeat':
				return <MdAirlineSeatLegroomNormal className={clsx(className)} />;
			case 'usbPower':
				return <MdUsb className={clsx(className)} />;
			case 'wifi':
				return <MdWifi className={clsx(className)} />;
			case 'xlSeat':
				return <MdEventSeat className={clsx(className)} />;
			default:
				return FallbackIcon ? (
					<FallbackIcon className={clsx(className)} />
				) : null;
		}
	} catch (error) {
		console.error('Error rendering amenity icon', amenityId, error);
	}
}
